


















import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import CalculatedDelivery from '@/dto/calculate/CalculatedDelivery'
import CalculatorDeliveriesItem from '@/components/calculator/CalculatorResult/CalculatorDeliveriesItem.vue'

@Component({
  components: { CalculatorDeliveriesItem },
})
export default class CalculatorDeliveries extends Vue {
  @Prop(String) title: string
  @Prop(Array) deliveries: CalculatedDelivery[]

  pagination = {
    rowsPerPage: 5000,
  }

  columns = [
    { name: 'name', label: 'Способ доставки', field: 'name', align: 'left' },
    {
      name: 'originalPrice',
      label: 'Цена (оригинал)',
      field: 'originalPrice',
      align: 'right',
    },
    {
      name: 'price',
      label: 'Цена ($)',
      field: 'price',
      align: 'right',
    },
  ]
}
